import { render, staticRenderFns } from "./ViewQuotation.vue?vue&type=template&id=9fc10c1a&scoped=true&"
import script from "./ViewQuotation.vue?vue&type=script&lang=js&"
export * from "./ViewQuotation.vue?vue&type=script&lang=js&"
import style0 from "./ViewQuotation.vue?vue&type=style&index=0&id=9fc10c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc10c1a",
  null
  
)

export default component.exports